import api from './api';

export interface Allegato {
  id: number;
  nomeFile: string;
  tipoFile: string;
  dimensione: number;
  movimentoId: number;
  createdAt: string;
}

/**
 * Upload a file attachment for a movimento
 */
const uploadAllegato = async (file: File, movimentoId: number): Promise<Allegato> => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('movimentoId', movimentoId.toString());

  const response = await api.post<Allegato>('/allegati/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

/**
 * Get all allegati for a movimento
 */
const getAllegatiByMovimento = async (movimentoId: number): Promise<Allegato[]> => {
  const response = await api.get<Allegato[]>(`/allegati/movimento/${movimentoId}`);
  return response.data;
};

/**
 * Download an allegato
 */
const downloadAllegato = async (id: number, nomeFile: string): Promise<void> => {
  const response = await api.get(`/allegati/${id}/download`, {
    responseType: 'blob',
  });

  const blob = new Blob([response.data]);
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', nomeFile);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

/**
 * Delete an allegato
 */
const deleteAllegato = async (id: number): Promise<void> => {
  await api.delete(`/allegati/${id}`);
};

const allegatiService = {
  uploadAllegato,
  getAllegatiByMovimento,
  downloadAllegato,
  deleteAllegato,
};

export default allegatiService;
